import React from 'react';
import { Control } from 'react-redux-form';
import { Link } from 'react-router-dom';
import {
  enumSecurityOrderTerms,
} from './Schemas/baseRrf';
import Select, { SELECT_STYLE } from './Controls/Select';
import InputField from './Controls/Field';
import CurrencyField from './Controls/CurrencyField';
import QuantityField from './Controls/QuantityField';

import './styles.css';

const getFields = (disabled, orderType, securityId, tradeDir) => {
  const fLimitPrice = {
    model: '.limitPrice',
    rowLabelComp: (
      <span styleName="formLabelNoMargin">Limit Price</span>
    ),
    RRFComp: Control,
    control: {
      component: CurrencyField,
      keyValue: orderType, // Use as the key to make sure component redraws with ordertype change
      disabled,
      textAlign: 'right',
      fontSize: '24px',
      width: '141px',
      parser: val => (val && val.replace(/\$|,/g, '')),
      placeholder: '$0.00',
      errors: {
        required: val => !val || !val.length,
      },
    },
    error: {
      messages: {
        required: 'Please enter the Limit Price.',
      },
    },
  };
  const fStopPrice = {
    model: '.stopPrice',
    rowLabelComp: (
      <span styleName="formLabelNoMargin">Stop Price</span>
    ),
    RRFComp: Control,
    control: {
      component: CurrencyField,
      keyValue: orderType,
      disabled,
      textAlign: 'right',
      fontSize: '24px',
      width: '141px',
      parser: val => (val && val.replace(/\$|,/g, '')),
      placeholder: '$0.00',
      errors: {
        required: val => !val || !val.length,
      },
    },
    error: {
      messages: {
        required: 'Please enter the Stop Price.',
      },
    },
  };
  const fQuantity = {
    model: '.requestedShareAmount',
    rowLabelComp: (
      <span styleName="formLabelNoMargin">Shares</span>
    ),
    RRFComp: Control,
    control: {
      component: QuantityField,
      decimalLimit: 0,
      keyValue: orderType,
      disabled,
      textAlign: 'right',
      fontSize: '24px',
      width: '141px',
      parser: val => (val && val.replace(/,/g, '')),
      placeholder: '0',
      errors: {
        required: val => !val || !val.length,
        greaterThanZero: val => val && !(val > 0),
      },
    },
    error: {
      messages: {
        required: 'Please enter the number of Shares.',
        greaterThanZero: 'Number of Shares must be greater than 0.',
      },
    },
  };
  const fExpiration = {
    model: '.term',
    rowLabelComp: (
      <Link to={`/security-trade/${securityId}/${tradeDir}/expiration-trade`} styleName="formLabelLink">Expiration</Link>
    ),
    RRFComp: Control,
    control: {
      component: Select,
      selectStyle: SELECT_STYLE.BLUE,
      keyValue: orderType,
      disabled,
    },
  };
  let fields = [];
  switch (orderType) {
    case 'dm':
      fields = [
        fQuantity,
      ];
      break;
    case 'dl':
      fields = [
        fLimitPrice,
        fQuantity,
        fExpiration,
      ];
      break;
    case 'ds':
      fields = [
        fStopPrice,
        fQuantity,
        fExpiration,
      ];
      break;
    case 'dsl':
      fields = [
        fStopPrice,
        fLimitPrice,
        fQuantity,
        fExpiration,
      ];
      break;
    // no default
  }
  return (fields);
};

const TradeSecurity = ({
  orderType,
  disabled,
  securityId,
  tradeDir,
}) => {
  const fields = getFields(disabled, orderType, securityId, tradeDir);
  return (
    <div>
      {fields.map((field) => {
        const { rowLabelComp, ...rest } = field;
        return (field.control.component !== Select ?
          <InputField key={field.model} fieldProps={field} /> :
          <div>
            <div styleName="formLabel">{field.rowLabelComp}</div>
            <InputField
              key={field.model}
              fieldProps={rest}
            >
              {enumSecurityOrderTerms.map(([key, value]) => (
                <option key={key} value={key}>{value}</option>
              ))}
            </InputField>
          </div>);
        })}
    </div>
  );
};

export default TradeSecurity;



// WEBPACK FOOTER //
// ./src/components/Forms/TradeSecurity.js